import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { TruckModel } from './TruckModels';
import { localizations } from '../localization/localization';
import DetailsBlock from '../components/tables/DetailsBlock';
import { DetailsValueBlock } from '../components/tables/DetailsValueBlock';
import DetailsContainer from '../components/tables/DetailsContainer';
import { renderPhoneDetails, renderPersonDetails, renderWebsiteDetails, renderEmailDetails, renderAnnouncementCountDetails, renderTruckProperties } from '../components/tables/DetailsHelpers';
import { EditItemProps, DeleteItemProps, CopyItemProps, MessagingProps } from '../common/props/itemProps';
import { toCommaDecimal } from '../utils/numberUtils';
import { connect } from 'react-redux';
import { ApplicationState } from "../store";
import * as TruckStore from '../trucks/store/truckStore'
import { bindActionCreators } from 'redux';
import ZeckitSmallWidget from '../common/ZeckitSmallWidget';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import { Tooltip } from 'react-leaflet';

interface RowDetailsProps extends EditItemProps<TruckModel>, DeleteItemProps<TruckModel>, CopyItemProps<TruckModel>, MessagingProps<TruckModel> {
    onGoToMap: (truck: TruckModel) => void;
}
interface RouteProps  { 
    trucks: TruckStore.TrucksState
}

type FreeTruckDetailsProps = TruckModel & RowDetailsProps & RouteProps;

const renderRoutes = (props: any) => {
    const trucks = props.trucks.routes
    let length = 0
    Object.keys(trucks).forEach((value, index) => {
        if (props.destinationCity !== null && trucks[value] !== undefined && trucks[value].to.id === props.destinationCity.id && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null)  {
            
            length = Math.round(trucks[value].distance)
        }
        
    });
    if (length !== 0) {
        return <span>~ {length.toFixed()} km</span>
    }
    else {
        return <span/>
    } 
}
const renderPrice = (props: any) => {
    const trucks = props.trucks.routes
    let price = 0.00
    let length = 0
    Object.keys(trucks).forEach((value, index) => {
        if (props.destinationCity !== null && trucks[value] !== undefined && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null )  {
            length = Math.round(trucks[value].distance)
            price = props.contractPrice * length
        }
    });
    if (price !== 0.00) {
        return <span>~ {price.toFixed(2)} €</span>
    }
    else {
        return <span/>
    }
}

function pad(num: number) {
  return ("0"+num).slice(-2);
}
function hhmmss(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}
function hmin(secs: number) {
  let minutes = Math.floor(secs / 60);
  secs = secs%60;
  const hours = Math.floor(minutes/60);
  minutes = minutes%60;
    
  if (hours < 1) {
    return `${minutes}${localizations.common.min}`;
  }
  return `${hours}${localizations.common.h} ${pad(minutes)}${localizations.common.min}`;
}

const renderTimeEstimate = (props: any) => {
    const trucks = props.trucks.routes
    let length = 0
    let secs = 0
    let formattedTime = ''
    Object.keys(trucks).forEach((value, index) => {
        if (props.destinationCity !== null && trucks[value] !== undefined && trucks[value].from.id === props.departureCity.id && trucks[value].to.id === props.destinationCity.id && trucks[value].distance !== null )  {
          length = Math.round(trucks[value].distance)
          secs = Math.ceil(length / 80 * 3600)
          formattedTime = hmin(secs)
        }
    });
    if (formattedTime !== '') {
        return <span>~ {formattedTime} {localizations.common.speedUsedForCalc}</span>
    }
    else {
        return null
    }
  }

const FreeTruckRowDetails: React.SFC<FreeTruckDetailsProps> = (props) => {

    const trackingStr = (props.isDistanceCheckEnabled ? 
        `${localizations.common.trackingActivated} ${props.searchDistance} ${localizations.common.km}` : 
        `${localizations.common.trackingNotActivated}`)

    const NotificationIcons = () => (
        (props.isOwn ? <Grid item title={trackingStr}>
            {props.isDistanceCheckEnabled ? <NotificationsIcon color="primary" /> : <NotificationsOffIcon color="error" />}
        </Grid> : null)
    );
    
    const Buttons = () => (
        <Grid container spacing={2}>
            {props.isEditEnabled && props.isEditEnabled(props) ?
                <Grid item>
                    <Button variant="outlined" color="primary" onClick={() => props.onEdit(props)}>{localizations.actions.edit}</Button>
                </Grid> : null}
            {props.isDeleteEnabled && props.isDeleteEnabled(props) ?
                <Grid item>
                    <Button variant="outlined" color="primary" onClick={() => props.onDelete(props)}>{localizations.actions.delete}</Button>
                </Grid>
                : null}
            {props.isCopyEnabled && props.isCopyEnabled(props) ?
                <Grid item>
                    <Button variant="outlined" color="primary" onClick={() => props.onCopy(props)}>{localizations.trucks.actions.copy}</Button>
                </Grid>
                : null}
            <Grid item>
                <Button variant="outlined" color="primary" onClick={() => props.onSendEmail(props)}>{localizations.actions.sendInfoByEmail}</Button>
            </Grid>
            <Grid item>
                <Button variant="outlined" color="primary" onClick={() => props.onSendEmailToReporter(props)}>{localizations.actions.sendEmailToReporter}</Button>
            </Grid>
            <Grid item>
                <Button variant="outlined" color="primary" onClick={(e) => props.onGoToMap(props)}>{localizations.actions.showOnMap}</Button>
            </Grid>
        </Grid>
    );
    return (
        <DetailsContainer>
            <DetailsBlock title={localizations.trucks.truckDetailsHeader}
                itemsRightOfTitle={<NotificationIcons />} 
                rightItems={<Buttons />}>
                {renderPersonDetails(props.coordinator, "Ilmoittaja")}
                <DetailsValueBlock title={localizations.common.properties}>
                    {renderTruckProperties(props.properties)}
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.trucks.licensePlateNumber}>
                    <Typography>{props.plateNumber}</Typography>
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.trucks.carrierCompany}>
                    <Typography>{props.carrierCompany}</Typography>
                </DetailsValueBlock >
                <DetailsValueBlock title={localizations.common.contractPriceCol}>
                    <Typography>{props.contractPrice ? `${toCommaDecimal(props.contractPrice)} €/km` : ""}</Typography>
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.trucks.distance}>
                    <Typography>{renderRoutes(props)}</Typography>
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.trucks.time}>
                    <Typography>{renderTimeEstimate(props)}</Typography>
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.common.totalPrice}>
                    <Typography>{renderPrice(props)}</Typography>
                </DetailsValueBlock>
                <DetailsValueBlock title={localizations.common.details}>
                    <Typography>{props.details}</Typography>
                </DetailsValueBlock>
            </DetailsBlock>
            <DetailsBlock title={localizations.trucks.companyDetailsHeader} rightItems={<ZeckitSmallWidget businessId={props.company.businessId} maxWidth={50} />}>
                <DetailsValueBlock title={localizations.common.companyName}>
                    <Typography>{props.company.name}</Typography>
                </DetailsValueBlock>
                {renderWebsiteDetails(props.company.website)}
                {props.company.phoneContacts.map((item, index) => <React.Fragment key={index}>
                    {renderPhoneDetails(item, index + 1)}
                </React.Fragment>)}
                {props.company.emailContacts.map((item, index) => <React.Fragment key={index}>
                    {renderEmailDetails(item, index + 1)}
                </React.Fragment>)}
                <React.Fragment>
                    {renderAnnouncementCountDetails(props.company.announcementCount)}
                </React.Fragment>

            </DetailsBlock>
        </DetailsContainer>
    );
};

const mapStateToProps = (state: ApplicationState) => {
    const { trucks } = state;
    return { trucks };
}



export default connect<any, any, any>(mapStateToProps)(FreeTruckRowDetails);


// WEBPACK FOOTER //
// ./src/trucks/FreeTruckRowDetails.tsx